<template>
  <div class="bg-primary flex flex-col justify-between h-full w-270 text-app-color ">
    <div class="pt-30 pl-30 overflow-y-auto">
      <h2 class="pl-20 mb-30 font-bold text-37">Settings</h2>

      <div v-if="isTeamAccount && logo">
        <img :key="logo" class="w-60 mb-15 ml-20" :src="logo" alt="logo">
      </div>

      <p
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'Account' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('Account')"
      >
        Your account
      </p>

      <p
        v-if="isTeamAccount"
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'TeamMembers' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('TeamMembers')"
      >
        Team members
      </p>

      <p
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'Design' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('Design')"
      >
        Design
      </p>

      <p
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'Preferences' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('Preferences')"
      >
        Preferences
      </p>

      <p
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'Keyboard' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('Keyboard')"
      >
        Keyboard shortcuts
      </p>

      <p
        v-if="showPlan"
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'Billing' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('Billing')"
      >
        Billing & invoices
      </p>

      <p
        v-if="showPlan"
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'Plans' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('Plans')"
      >
        Your Plan
      </p>

      <p
        v-if="showTrash"
        class="pl-20 py-8 leading-small cursor-pointer rounded-4"
        :class="[
          activeState === 'Trash' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="update('Trash')"
      >
        Trash
      </p>

      <p
        v-if="isFreePlan && !isTeamAccount"
        class="pl-20 py-8 leading-small cursor-pointer rounded-4 flex items-center font-semibold"
        :class="[
          isHueTheme ? 'text-link-color' : 'text-main-color',
          activeState === 'Upgrade to pro' ? activeClass : '',
          isDarkMode ? 'hover:bg-hover' : 'hover:bg-grey-450'
        ]"
        @click="upgradeToPro"
      >
        <img :src="require(`@/assets/images/thunder.svg`)" alt="" class="w-16 h-16 mr-10">

        Upgrade to pro
      </p>
      <ProgressBarModule v-if="isFreePlan || (isTrialPlan && isOwner)" />
    </div>

    <!-- L O G  O U T  B U T T O N -->
    <div>
      <ButtonModule
        has-hover
        text="Log out"
        class="text-app-color text-14 ml-25 mb-20"
        @click="logout"
      />
    </div>
  </div>
</template>

<script>
import ProgressBarModule from '@/components/shared/ProgressBarModule'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

import { mapGetters, mapMutations, mapState } from 'vuex'

import localStorageService from '@/core/local-storage'

export default {

  components: {
    ProgressBarModule,
    ButtonModule
  },

  computed: {
    ...mapState({
      activeState: state => state.settings.activeState,
      user: state => state.profile.user,
      team: state => state.team.team,
      member: state => state.team.member
    }),

    ...mapGetters(['isFreePlan', 'isDarkMode', 'isHueTheme', 'isAdmin', 'isOwner', 'isTeamAccount', 'isTrialPlan']),

    activeClass () {
      return this.isDarkMode ? 'font-semibold bg-hover' : 'font-semibold bg-grey-450'
    },

    showTrash () {
      return this.isTeamAccount ? this.isAdmin : true
    },

    showPlan () {
      return this.isTeamAccount ? this.member.hasBillingAccess : true
    },

    logo () {
      return this.team?.teamLogo?.url
    }
  },

  methods: {
    ...mapMutations(['changeActiveState', 'toggleAside', 'toggleSettingsModal']),

    update (value) {
      this.changeActiveState(value)
    },

    upgradeToPro () {
      if (this.user) {
        window.open(`https://helloivy.co/upgrade?userId=${this.user.id}`, '_blank')
      }
    },

    logout () {
      this.$router.push({ name: 'Login' })
      this.toggleSettingsModal(false)
      localStorageService.removeItem('lastOpenedProject')
    }
  }
}
</script>
